export default __webpack_public_path__ + "static/media/AMRLogo.aeb55ef4.png";